export enum actionTypes {
  LOCALIDADES_FETCH = 'LOCALIDADES_FETCH',
  LOCALIDADES_SUCCESS = 'LOCALIDADES_SUCCESS',
  LOCALIDADES_ERROR = 'LOCALIDADES_ERROR',
  LOCALIDADES_RESET = 'LOCALIDADES_RESET',
}

export enum LocalidadesStatus {
  Idle,
  Loading,
  Error,
  Success,
}

export interface Localidad {
  id: number
  nombre: string
}

export interface LocalidadesState {
  idProvincia?: number
  status: LocalidadesStatus
  localidades: Array<Localidad>
}

export interface LocalidadesFetch {
  type: typeof actionTypes.LOCALIDADES_FETCH
  payload: { idProvincia }
}

export interface LocalidadesSuccess {
  type: typeof actionTypes.LOCALIDADES_SUCCESS
  payload: { localidades }
}

export interface LocalidadesError {
  type: typeof actionTypes.LOCALIDADES_ERROR
  payload: null
}

export interface LocalidadesReset {
  type: typeof actionTypes.LOCALIDADES_RESET
  payload: null
}

export type LocalidadesActions = LocalidadesFetch | LocalidadesSuccess | LocalidadesError | LocalidadesReset

export const initialState: LocalidadesState = {
  status: LocalidadesStatus.Idle,
  localidades: [],
}
